<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-list-group>
          <b-list-group-item class="d-flex flex-column">
            <div class="d-flex">
              {{ contract.first_name }} {{ contract.last_name }}
              <b-link class="pl-1" :href="`mailto:${contract.email_address}`"
                ><b-icon-envelope></b-icon-envelope
              ></b-link>
            </div>
            <small class="text-muted">Developer</small>
          </b-list-group-item>
          <b-list-group-item class="d-flex flex-column">
            {{ contract.vendor_id ? contract.vendor_id : 'Not on file' }}
            <small class="text-muted">Vendor ID</small>
          </b-list-group-item>
          <b-list-group-item
            v-if="contract.project_tags"
            class="d-flex flex-column"
          >
            {{ contract.project_tags }}
            <small class="text-muted">Project tags</small>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col md="4">
        <b-list-group>
          <b-list-group-item class="d-flex flex-column">
            {{ contract.ipa_type }}
            <small class="text-muted">IPA type</small>
          </b-list-group-item>
          <b-list-group-item class="d-flex flex-column">
            ${{ contract.amount_to_be_paid }}
            <small class="text-muted">Payment amount</small>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          label="Status"
          label-cols-md="3"
          label-align-md="right"
          :label-for="`select-status-${contract.id}`"
        >
          <b-select
            @input="updateContractStatus"
            :id="`select-status-${contract.id}`"
            v-model="contract.status"
            :options="statusOptions"
          >
          </b-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    props: { contract: Object, getData: Function },
    data() {
      return {
        statusOptions: [
          'To be paid',
          'Requisition entered',
          { value: 'Sent for payment', text: 'Paid' },
        ],
      }
    },
    computed: {},
    methods: {
      async updateContractStatus() {
        try {
          await this.$store.dispatch('cd_callAPI', {
            url: `/d/payments/${this.contract.id}/status`,
            method: 'PUT',
            data: {
              new_status: this.contract.status,
            },
          })
          this.$root.$bvToast.toast(
            `You have succesfully updated this contracts's payment status.`,
            {
              title: 'Success',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 1000,
              variant: 'success',
            },
          )
        } catch (err) {
          this.$root.$bvToast.toast(
            `There was an issue updating the stauts of this contract: ${err.message}.`,
            {
              title: 'Error',
              toaster: 'b-toaster-top-center',
              variant: 'danger',
            },
          )
        } finally {
          this.getData()
        }
      },
    },
  }
</script>
